import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckPermissions, DownloadFile } from './Shared';

const ReportJobsAwaitingPaymentData = () => {
    let navigate = useNavigate();
    const [loading, setLoading] = React.useState(true);

    React.useEffect(() => {
        getData();
    }, [])

    const getData = async () => {
        var hasPermission = await CheckPermissions("RunReports");
        if (hasPermission) {
            setLoading(false);
        } else {
            navigate("/accessdenied")
        }
    }

    const runReport = (e: any) => {
        e.preventDefault();
        //run the report and export the data
        runRpt();
    }

    const runRpt = () => {
        var url = "/report/JobsAwaitingPayment/-1/-1/-1/-1/-1";
        window.open(url, '_blank');
    }

    const exportReport = (e: any) => {
        e.preventDefault();

        exportRpt();
    }

    const exportRpt = async () => {
        const apiURL = 'ExportJobsAwaitingPaymentReportData';
        var filename = "JobsAwaitingPayment.xlsx";
        await DownloadFile(apiURL, filename);
    }

    const renderDetails = (
        <div>
            <div>
                <h1>Jobs Awaiting Payment Report</h1>
            </div>
            <div>
                <button className="defaultbutton marginRight10" type='button' onClick={runReport}>Run Report</button>
                <button className="defaultbutton" type='button' onClick={exportReport}>Export to Excel</button>
            </div>
        </div>
    );

    let contents = loading
        ? <p><em>Loading...</em></p>
        : renderDetails;

    return (<div>
        {contents}
    </div>)

}

export default ReportJobsAwaitingPaymentData;